import { MarketingSettingEnabledType, OneOffType, QuizType, useGetAdminActions } from '../generated'

// TODO: We want to have this options from the backend, see: https://dhlbnl.atlassian.net/browse/CON-8041
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const actionTypes: any[] = [
  {
    label: 'Eenmalig',
    value: OneOffType.OneOff,
  },
  {
    label: 'Marketing optie',
    value: MarketingSettingEnabledType.MarketingSettingEnabled,
  },
  {
    label: 'Quiz',
    value: QuizType.Quiz,
  },
]

type Props = {
  promotionId: string | undefined
}

export const usePossibleActionTypes = ({ promotionId }: Props) => {
  const { data: promotions } = useGetAdminActions({
    query: {},
  })

  const checkIfTypeExistInPromotions = (value: string) =>
    promotions?.some((promotion) => {
      if (
        promotion.actionType === MarketingSettingEnabledType.MarketingSettingEnabled &&
        promotion.actionId !== promotionId
      ) {
        return value === MarketingSettingEnabledType.MarketingSettingEnabled
      }
      return false
    })

  const possibleActionTypes = [...actionTypes].filter((type) => !checkIfTypeExistInPromotions(type.value))

  return {
    possibleActionTypes,
  }
}
